import {Space, SpaceScreenGroup} from './spaces';
import {DateTime} from 'util/time';
import {Bounds2D} from "util/geometry";

export interface Design {
  code: string;
  name: string;
  space: Space;
  created: DateTime;
  sourceType: DesignSourceType;
  screenGroups: DesignScreenGroup[];
}

export interface NewDesign extends Omit<Design, 'code'|'space'|'screenGroups'|'created'> {
  space: string;
}

export interface DesignThumbnailElement {
  bounds: Bounds2D;
  rotation: number;
  depth: number;
  thumbnails: string[];
}

export interface DesignSourceData {
  source_file_url: string
  source_file_key?: string
  source_file_type?: DesignMediaType
  canva_design_id?: string
}

export interface DesignScreenGroup {
  screenGroup: SpaceScreenGroup;
  sourceData: DesignSourceData;
  thumbnailImageURL: URL|null;
  syncStatus: {thumbnail: DesignScreenGroupSyncStatus, data: DesignScreenGroupSyncStatus};
  elementSources: DesignSourceType[]|null;
  ready: boolean;
  thumbnailElements: DesignThumbnailElement[]|null;
}

export enum DesignScreenGroupSyncStatus {
  INITIALIZING = 'initializing',
  INIT_FAILED = 'initFailed',
  SYNCING = 'syncing',
  SYNCED = 'synced'
}

export enum DesignSourceType {
  Canva = 'canva',
  File = 'file',
  YouTube = 'youtube'
}

export enum DesignMediaType {
  Image = 'image',
  Video = 'video',
}

export enum DesignField {
  Space = 'space',
  SpaceRegions = 'space.regions',
  DesignScreenGroups = 'screen_groups',
  ScreenGroups = 'screen_groups.screen_group',
  DesignElements = 'screen_groups.elements',
  DesignElementSources = 'screen_groups.element_sources',
  DesignThumbnailElements = 'screen_groups.thumbnail_elements'
}
